import { EditLinkButton } from "Components/Shared/Buttons/EditLinkButton";
import { ResponsiveDialog } from "Components/Shared/Dialogs/ResponsiveDialog";
import { PublicInfoCard } from "Components/Social/PublicInfoCard";
import { BioForm } from "Components/UserAccount/Shared/PublicInformation/BioForm";
import { useUserInfoQuery } from "Auth/Api/Queries/useUserInfoQuery";
import { Resources, useResource } from "Translations/Resources";
import { useState } from "react";

/** Bio card of the public-information tab (ZS-1320): free text shown on the public profile. */
export const BioCard = () => {
  const { t } = useResource();
  const { data: userInfo } = useUserInfoQuery();
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  return (
    <>
      <PublicInfoCard
        label={t(Resources.Social.PublicPermissions.BioLabel)}
        value={userInfo?.bio ?? null}
        action={<EditLinkButton onClick={() => setIsDialogOpen(true)} />}
      />
      <ResponsiveDialog
        isOpen={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        title={t(Resources.Social.PublicPermissions.BioLabel)}
      >
        <BioForm onSuccess={() => setIsDialogOpen(false)} />
      </ResponsiveDialog>
    </>
  );
};
